<template>
    <tenants-store
        v-slot="{
            sid,
            error,
            is_loading,
            has_loaded,
            store
        }"
        @success="onTenantsStoreSuccess"
        @error="onTenantsStoreError"
    >
        <with-variables
            :variables="{
                is_saving: has_loaded || is_loading
            }"
            v-slot="{
                is_saving
            }"
        >
            <base-form
                @submit="store(_.extend(form, {
                    intended: $route.query.intended
                }))"
            >
                <div class="px-6 pt-6 border-b">
                    <validator-alert :sid="sid" />

                    <h1 class="mb-6 text-lg font-normal text-center">
                        Create a <strong>tenant</strong> profile
                    </h1>

                    <base-alert
                        v-if="$route.query.intention === 'listing-message'"
                        level="info"
                    >
                        <template slot="heading">
                            Tenant profile required
                        </template>

                        <template slot="content">
                            We'll send your message once you've created a tenant profile.
                        </template>
                    </base-alert>

                    <form-item
                        :sid="sid"
                        :is-required="true"
                        name="first_name"
                    >
                        <template slot="label">First name</template>

                        <input-text
                            v-model="form.first_name"
                            :sid="sid"
                            :autofocus="true"
                            :disabled="is_saving"
                            name="first_name"
                        />
                    </form-item>

                    <form-item
                        :sid="sid"
                        :is-required="true"
                        name="last_name"
                    >
                        <template slot="label">Last name</template>

                        <input-text
                            v-model="form.last_name"
                            :sid="sid"
                            :disabled="is_saving"
                            name="last_name"
                        />
                    </form-item>
                </div>

                <div class="px-6 py-3 text-right rounded-b bg-grey-bg">
                    <base-button
                        :is-loading="is_saving"
                        class="w-full btn-blue"
                    >
                        Create Profile
                    </base-button>
                </div>

                <error-modal
                    v-if="error && $error.is(error, { exclude: [400, 422] })"
                    :error="error"
                />
            </base-form>
        </with-variables>
    </tenants-store>
</template>

<script>
    import scroll from '../../../support/scroll'
    import HeadMixin from '../../../mixins/head'
    import TenantsStore from '../../../components/tenants-store'

    export default {
        mixins: [
            HeadMixin
        ],
        components: {
            TenantsStore
        },
        data () {
            return {
                form: {
                    first_name: '',
                    last_name: ''
                }
            }
        },
        methods: {
            head () {
                return {
                    title: 'Create a tenant profile'
                }
            },
            onTenantsStoreSuccess ({ meta }) {
                this.$track(
                    'auth.tenants.create',
                    'form-submission',
                    'A user has created a tenant persona'
                )

                setTimeout(() => {
                    window.location = meta.redirect
                }, 0)
            },
            onTenantsStoreError () {
                scroll.toTop()
            }
        }
    }
</script>
